"use client"

import React, { useRef, useEffect, useState } from "react";
import PDFViewer from "./PDFViewer";
import PDFFullScreen from "./PDFFullScreen";
import NoInformation from "../Common/NoInformation";

export default function Page(props: any) {

    const URL = props?.url;
    return (
        <>
            {
                URL?.length ?
                    (props?.type == "pc" ?
                        <PDFViewer url={URL} /> : <PDFFullScreen onClose={props.onClose}><PDFViewer url={URL} PDFProps={{ spreadMode: 1 }} /></PDFFullScreen>)
                    :
                    <NoInformation />
            }
        </>
    )
}